import { DollarSign, TrendingUp, CreditCard, Receipt, BarChart3 } from 'lucide-react';

export const FinancialPage = () => {
   return (
      <div className='space-y-6'>
         {/* Header */}
         <div className='border-b border-gray-200 pb-4'>
            <div className='flex items-center gap-x-3'>
               <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-green-600'>
                  <DollarSign className='h-6 w-6 text-white' />
               </div>
               <div>
                  <h1 className='text-2xl font-bold text-gray-900'>Financial Overview</h1>
                  <p className='text-sm text-gray-500'>
                     Monitor financial metrics and revenue analytics
                  </p>
               </div>
            </div>
         </div>

         {/* Stats Cards */}
         <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4'>
            <div className='bg-white overflow-hidden shadow rounded-lg'>
               <div className='p-5'>
                  <div className='flex items-center'>
                     <div className='flex-shrink-0'>
                        <TrendingUp className='h-6 w-6 text-green-600' />
                     </div>
                     <div className='ml-5 w-0 flex-1'>
                        <dl>
                           <dt className='text-sm font-medium text-gray-500 truncate'>
                              Total Revenue
                           </dt>
                           <dd className='text-lg font-medium text-gray-900'>$45,231.89</dd>
                        </dl>
                     </div>
                  </div>
               </div>
            </div>

            <div className='bg-white overflow-hidden shadow rounded-lg'>
               <div className='p-5'>
                  <div className='flex items-center'>
                     <div className='flex-shrink-0'>
                        <CreditCard className='h-6 w-6 text-blue-600' />
                     </div>
                     <div className='ml-5 w-0 flex-1'>
                        <dl>
                           <dt className='text-sm font-medium text-gray-500 truncate'>
                              Active Subscriptions
                           </dt>
                           <dd className='text-lg font-medium text-gray-900'>2,350</dd>
                        </dl>
                     </div>
                  </div>
               </div>
            </div>

            <div className='bg-white overflow-hidden shadow rounded-lg'>
               <div className='p-5'>
                  <div className='flex items-center'>
                     <div className='flex-shrink-0'>
                        <Receipt className='h-6 w-6 text-yellow-600' />
                     </div>
                     <div className='ml-5 w-0 flex-1'>
                        <dl>
                           <dt className='text-sm font-medium text-gray-500 truncate'>
                              Monthly Transactions
                           </dt>
                           <dd className='text-lg font-medium text-gray-900'>12,234</dd>
                        </dl>
                     </div>
                  </div>
               </div>
            </div>

            <div className='bg-white overflow-hidden shadow rounded-lg'>
               <div className='p-5'>
                  <div className='flex items-center'>
                     <div className='flex-shrink-0'>
                        <DollarSign className='h-6 w-6 text-purple-600' />
                     </div>
                     <div className='ml-5 w-0 flex-1'>
                        <dl>
                           <dt className='text-sm font-medium text-gray-500 truncate'>
                              Average Order Value
                           </dt>
                           <dd className='text-lg font-medium text-gray-900'>$19.23</dd>
                        </dl>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         {/* Main Content Area */}
         <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
            {/* Revenue Chart Placeholder */}
            <div className='bg-white shadow rounded-lg'>
               <div className='px-4 py-5 sm:p-6'>
                  <h3 className='text-lg leading-6 font-medium text-gray-900'>Revenue Overview</h3>
                  <div className='mt-5'>
                     <div className='h-64 bg-gray-50 rounded-lg flex items-center justify-center'>
                        <div className='text-center'>
                           <BarChart3 className='mx-auto h-12 w-12 text-gray-400' />
                           <p className='mt-2 text-sm text-gray-500'>Revenue chart coming soon</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Recent Transactions */}
            <div className='bg-white shadow rounded-lg'>
               <div className='px-4 py-5 sm:p-6'>
                  <h3 className='text-lg leading-6 font-medium text-gray-900 mb-4'>
                     Recent Transactions
                  </h3>
                  <div className='space-y-3'>
                     {[
                        {
                           id: 1,
                           amount: '$29.99',
                           description: 'Premium Subscription',
                           time: '2 hours ago',
                        },
                        {
                           id: 2,
                           amount: '$15.50',
                           description: 'Trip Booking Fee',
                           time: '4 hours ago',
                        },
                        {
                           id: 3,
                           amount: '$45.00',
                           description: 'Photo Package',
                           time: '6 hours ago',
                        },
                        { id: 4, amount: '$12.99', description: 'Monthly Plan', time: '1 day ago' },
                     ].map((transaction) => (
                        <div
                           key={transaction.id}
                           className='flex items-center justify-between py-2'
                        >
                           <div className='flex items-center'>
                              <div className='h-8 w-8 bg-green-100 rounded-full flex items-center justify-center'>
                                 <DollarSign className='h-4 w-4 text-green-600' />
                              </div>
                              <div className='ml-3'>
                                 <p className='text-sm font-medium text-gray-900'>
                                    {transaction.description}
                                 </p>
                                 <p className='text-xs text-gray-500'>{transaction.time}</p>
                              </div>
                           </div>
                           <span className='text-sm font-medium text-green-600'>
                              {transaction.amount}
                           </span>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};
 